import type { Uuid } from "@/types"

export enum WorkflowTags {
  create = "create",
  update = "update",
  delete = "delete",
  node = "node",
  relay = "relay",
  dns = "dns",
}

export enum ExecStatus {
  Pending = "pending",
  Running = "running",
  Success = "success",
  Error = "error",
}

export enum ActionType {
  CreateInstance = "create_instance",
  // Update instance is currently unused
  // UpdateInstance = "update_instance",
  DeleteInstance = "delete_instance",
  CreateBuild = "create_build",
  DeleteBuild = "delete_build",
  CreateDeploy = "create_deploy",
  UpdateDeploy = "update_deploy",
  DeleteDeploy = "delete_deploy",
}

export type Action = {
  id: Uuid
  created_at: Date
  updated_at: Date
  workflow_id: Uuid
  index: number
  type: ActionType
  // TODO - type needs refinement
  params: Record<string, string>
  deps?: Uuid[]
  status: ExecStatus
  result?: Uuid
  log?: string
}

export type Workflow = {
  id: Uuid
  created_at: Date
  updated_at: Date
  project_id: Uuid
  name: string
  actions: Action[]
  status: ExecStatus
  tags: string[]
}

export type WorkflowUpdate =
  | {
      msg_type: "action_status_change"
      id: Uuid
      status: ExecStatus
      index: number
      type: ActionType
    }
  | { msg_type: "action_log"; action_id: Uuid; message: string }
  | { msg_type: "exec_status"; status: ExecStatus }

export type ActionLog = {
  action_id: Uuid
  message: string
}
